import * as Types from './notificationActionTypes.js'

const initialState = {
    counter: 0
};

export default function notification(state = initialState, action) {
    switch (action.type) {
        case Types.SET_COUNTER:
            // console.log(state.counter);
            // console.log(action.counter);
            // if (state.counter !== action.counter) {
                return Object.assign({}, state, { counter: ++state.counter });
            // }
            // console.log(state.counter);
            // return state;
            
        case Types.RESET_COUNTER:
            return Object.assign({}, state, { counter: 0 });
        default:
            return state;
    }
}